import React from 'react';
import profile from '../data/profile';

const Skills = () => {
  const skillCategories = profile.skills.categories;

  const technologies = profile.skills.technologies;

  return (
    <section id="skills" className="py-16 sm:py-20 bg-slate-900">
      <div className="container mx-auto px-4 sm:px-6">
        {/* Header */}
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4 sm:mb-6">
            Mes <span className="text-gradient">compétences</span>
          </h2>
          <p className="text-base sm:text-lg lg:text-xl text-gray-300 max-w-3xl mx-auto">
            Une expertise approfondie dans les technologies modernes pour créer des solutions web performantes et innovantes.
          </p>
        </div>

        {/* Skills Grid */}
        <div className="grid lg:grid-cols-2 gap-8 sm:gap-12 mb-12 sm:mb-16">
          {skillCategories.map((category, categoryIndex) => (
            <div key={categoryIndex} className="space-y-4 sm:space-y-6">
              <h3 className="text-xl sm:text-2xl font-bold text-white mb-4 sm:mb-6 text-center lg:text-left">{category.title}</h3>
              <div className="space-y-3 sm:space-y-4">
                {category.skills.map((skill, skillIndex) => (
                  <div key={skillIndex} className="space-y-2">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center space-x-2 sm:space-x-3">
                        <img 
                          src={skill.logo} 
                          alt={skill.name}
                          className="w-5 h-5 sm:w-6 sm:h-6"
                        />
                        <span className="font-semibold text-gray-200 text-sm sm:text-base">{skill.name}</span>
                      </div>
                      <span className="text-xs sm:text-sm text-gray-300">{skill.level}%</span>
                    </div>
                    <div className="w-full bg-gray-700 rounded-full h-1.5 sm:h-2">
                      <div 
                        className="bg-gradient-primary h-1.5 sm:h-2 rounded-full transition-all duration-1000 ease-out"
                        style={{ width: `${skill.level}%` }}
                      ></div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Technologies Grid */}
        <div className="bg-slate-700 rounded-2xl p-4 sm:p-6 lg:p-8">
          <h3 className="text-xl sm:text-2xl font-bold text-white text-center mb-6 sm:mb-8">
            Technologies que j'utilise
          </h3>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 xl:grid-cols-9 gap-3 sm:gap-4 lg:gap-6">
            {technologies.map((tech, index) => (
              <div 
                key={index}
                className="group flex flex-col items-center space-y-2 sm:space-y-3 p-3 sm:p-4 bg-slate-600 rounded-xl hover:shadow-lg transition-all duration-300 transform hover:scale-105"
              >
                <div className="w-8 h-8 sm:w-10 sm:h-10 lg:w-12 lg:h-12 flex items-center justify-center">
                  <img 
                    src={tech.logo} 
                    alt={tech.name}
                    className="w-6 h-6 sm:w-7 sm:h-7 lg:w-8 lg:h-8 object-contain"
                  />
                </div>
                <span className="text-xs sm:text-sm font-medium text-gray-200 text-center">
                  {tech.name}
                </span>
              </div>
            ))}
          </div>
        </div>

        {/* Additional Skills */}
        <div className="mt-12 sm:mt-16 grid sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          <div className="text-center p-4 sm:p-6 bg-white rounded-xl shadow-lg">
            <div className="w-12 h-12 sm:w-16 sm:h-16 bg-gradient-primary rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">
              <svg className="w-6 h-6 sm:w-8 sm:h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" />
              </svg>
            </div>
            <h4 className="text-lg sm:text-xl font-bold text-dark-800 mb-2">Développement</h4>
            <p className="text-sm sm:text-base text-gray-600">
              Applications web modernes avec les dernières technologies
            </p>
          </div>

          <div className="text-center p-4 sm:p-6 bg-white rounded-xl shadow-lg">
            <div className="w-12 h-12 sm:w-16 sm:h-16 bg-gradient-primary rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">
              <svg className="w-6 h-6 sm:w-8 sm:h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
              </svg>
            </div>
            <h4 className="text-lg sm:text-xl font-bold text-dark-800 mb-2">Design</h4>
            <p className="text-sm sm:text-base text-gray-600">
              Interfaces utilisateur intuitives et esthétiques
            </p>
          </div>

          <div className="text-center p-4 sm:p-6 bg-white rounded-xl shadow-lg sm:col-span-2 lg:col-span-1">
            <div className="w-12 h-12 sm:w-16 sm:h-16 bg-gradient-primary rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">
              <svg className="w-6 h-6 sm:w-8 sm:h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
              </svg>
            </div>
            <h4 className="text-lg sm:text-xl font-bold text-dark-800 mb-2">Performance</h4>
            <p className="text-sm sm:text-base text-gray-600">
              Optimisation pour des applications rapides et fluides
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;
